export default __webpack_public_path__ + "static/media/logo_H.b84030af.svg";